import React, { Component as C } from "react"
import PropTypes from "prop-types"
import classNames from "classnames"
import { debounce } from "lodash"

import styles from "./index.less"

class DialogV3 extends C {
  static propTypes = {
    actions: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.element), PropTypes.element]),
  }

  static defaultProps = {
    actions: [],
  }

  state = {
    isScrollbarFixed: false,
    showMovement: false,
  }

  constructor(props) {
    super(props)

    this._onWindowClick = (e) => {
      if (e.defaultPrevented) {
        return
      }

      var el = this._containerRef
      if (el !== e.target && !this.isDescendant(el, e.target)) {
        this.props.close && this.props.close()
      }
    }
  }

  showScrollbar() {
    var windowHeight = window.innerHeight

    if (windowHeight < document.body.scrollHeight && !this.state.isScrollbarFixed) {
      if (this.props.fixScrollbar) {
        this.props.fixScrollbar("add")
      } else {
        App.vent.trigger("fixedScrollbar", "add")
        document.body.classList.add(styles.modalOpen)
      }

      this.setState({
        isScrollbarFixed: true,
      })
    }
  }

  hideScrollbar() {
    if (this.props.fixScrollbar) {
      this.props.fixScrollbar("remove")
    } else {
      App.vent.trigger("fixedScrollbar", "remove")
      document.body.classList.remove(styles.modalOpen)
    }
  }

  isDescendant(parent, child) {
    let node = child
    if (this.closeIcon == child && this.refs.actions == child) {
      return true
    }

    while (node !== null) {
      if (node === parent) {
        return true
      }

      node = node.parentNode
    }

    return false
  }

  close() {
    this.props.close && this.props.close()
  }

  componentDidMount() {
    window.addEventListener("click", this._onWindowClick)
    window.addEventListener("resize", this.onResizeDebounced)
    this.showScrollbar()

    this.setState({
      showMovement: true,
    })
  }

  componentWillUnmount() {
    window.removeEventListener("click", this._onWindowClick)
    window.removeEventListener("resize", this.onResizeDebounced)
    this.hideScrollbar()
  }

  onResizeDebounced = debounce(() => {
    this.showScrollbar()
  })

  setHiddenContainerRef = (hiddenContainerRef) => {
    this._hiddenContainerRef = hiddenContainerRef
  }

  setContainerRef = (containerRef) => {
    this._containerRef = containerRef
  }

  render() {
    let {
      actions,
      contentDisabled,
      classNameDialog,
      backgroundDialogClassName,
      disabled,
      className,
      children,
    } = this.props

    let _this = this
    let backgroundDialog = classNames(
      "background-dialog-notification-fix",
      styles.backgroundDialog,
      contentDisabled ? "disabled" : null,
      backgroundDialogClassName,
    )
    let containerForScroll = classNames(styles.containerForScroll, classNameDialog)

    if (actions.map) {
      actions = actions.map((action, index) => (
        <span key={index} onClick={disabled ? null : _this.close.bind(_this)}>
          {action}
        </span>
      ))
    }

    return (
      <div className={backgroundDialog}>
        <div
          className={classNames(containerForScroll, {
            [styles.showMovement]: this.state.showMovement,
          })}>
          <div
            ref={this.setHiddenContainerRef}
            style={{
              visibility: "hidden",
              width: "100%",
            }}
          />
          <div
            ref={this.setContainerRef}
            className={classNames(styles.container, className, styles.containerFixed)}
            onClick={(e) => {
              this.props.onClick && this.props.onClick(e)
            }}>
            {children}
            {actions.length > 0 && (
              <div className={styles.actions} ref="actions">
                {actions}
              </div>
            )}
          </div>
        </div>
      </div>
    )
  }
}

export default DialogV3
